import { SearchScenarioId } from '../../../store/schema/SearchScenarioId';
import { getIconForFile } from 'owa-file-icon';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { OdspFileSuggestion } from 'owa-search-service';
import OpenInNewTabSuggestion from '../OpenInNewTabSuggestion';
import * as React from 'react';
import { owaDate, differenceInSeconds } from 'owa-datetime';
import abbreviatedFormatDuration from 'owa-duration-formatter/lib/abbreviated';
import loc, { format } from 'owa-localize';
import { openedAgo_1 } from './OdspFileSearchSuggestion.locstring.json';

const universalSuggestionStyles = require('../searchSuggestion/SearchSuggestion.scss');
const classNames = require('classnames/bind').bind(universalSuggestionStyles);

const fileSuggestionStyles = require('./FileSearchSuggestion.scss');

export interface OdspFileSearchSuggestionProps {
    index: number;
    scenarioId: SearchScenarioId;
    suggestion: OdspFileSuggestion;
    suggestionSetTraceId: string;
    focusSearchInput: () => void;
}

const OdspFileSearchSuggestion = (props: OdspFileSearchSuggestionProps) => {
    const { index, scenarioId, suggestion, suggestionSetTraceId, focusSearchInput } = props;
    const fileIcon = getIconForFile(suggestion.FileName);

    const timeLastAccessedAsOwaDate = owaDate('UTC', suggestion.DateTimeLastAccessed);
    const secondsFromLastAccessed = differenceInSeconds(owaDate(), timeLastAccessedAsOwaDate);
    const formattedSecondsFromLastAccessed = abbreviatedFormatDuration(secondsFromLastAccessed, {
        maxUnits: 1,
    });

    const suggestionContent = (
        <div className={fileSuggestionStyles.container}>
            <div className={fileSuggestionStyles.fileIconContainer}>
                <i className={fileIcon.small} />
            </div>
            <div className={fileSuggestionStyles.fileContentContainer}>
                <div className={fileSuggestionStyles.fileName}>{suggestion.FileName}</div>
                <div className={fileSuggestionStyles.fileAuthorOrSender}>
                    {suggestion.FileAuthor}
                </div>
            </div>
            <Icon
                className={classNames(
                    universalSuggestionStyles.icon,
                    universalSuggestionStyles.newTabIcon
                )}
                iconName={ControlIcons.OpenInNewTab}
            />
            <div className={fileSuggestionStyles.fileDateTime}>
                {format(loc(openedAgo_1), formattedSecondsFromLastAccessed)}
            </div>
        </div>
    );

    return (
        <OpenInNewTabSuggestion
            index={index}
            scenarioId={scenarioId}
            suggestion={suggestion}
            suggestionSetTraceId={suggestionSetTraceId}
            urlToNavigateTo={suggestion.FileUrl}
            ariaLabel={suggestion.FileName}
            suggestionContent={suggestionContent}
            focusSearchInput={focusSearchInput}
        />
    );
};

export default OdspFileSearchSuggestion;
